"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";

export default function Games() {
  const [city, setCity] = useState("SP");

  useEffect(() => {
    const storedCity = window.localStorage.getItem("state");

    if (storedCity) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setCity(storedCity);
    }
  }, []);

  return (
    <section
      // className="games-section reveal-up lg:min-h-lvw min-h-screen"
      className="games-section reveal-up"
      style={{
        backgroundColor: "#2033ef",
        // backgroundColor: "red",

        height: 780,
        paddingTop: 40,
      }}
      id="jogos"
    >
      <div className="flex flex-col justify-center p-5">
        <div className="flex justify-start reveal-scale">
          <div className="text-center flex justify-center items-center flex-col w-full">
            <h1 className="font-extrabold text-white text-[26px] text-center uppercase">
              Próximos jogos na <h1 className="text-[#fec822]">casa CAZÉTV</h1>
            </h1>
          </div>
        </div>
      </div>

      <div className="flex justify-center flex-col items-center">
        <iframe
          src={`https://tm1-copa.vercel.app/partida/?date=${new Date().toISOString()}&city=${city}`}
          className="w-[95%] h-auto min-h-[580px]"
        />

        <Link href="programacao" target="_self">
          <Image
            src="/images/programacao.svg"
            alt="Programação completa"
            width={250}
            height={90}
            priority
          />
        </Link>
      </div>

      <style jsx>{`
        .games-section {
          min-height: 260px;
          // background: var(--brand-blue);
          // background: "#000";
          // padding: 64px 0 72px;
          color: white;
          scroll-margin-top: 6.5rem;
        }

        .games-content {
          display: grid;
          justify-items: center;
          gap: 26px;
          text-align: center;
        }

        .games-content h2 {
          max-width: 760px;
        }

        .games-content p {
          max-width: 560px;
          line-height: 1.7;
          font-size: 16px;
        }

        .match-list {
          width: min(720px, 100%);
          display: grid;
          gap: 10px;
          margin: 12px 0 38px;
        }

        .match-item {
          min-height: 52px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          border-bottom: 1px solid rgba(254, 200, 34, 0.38);
          color: var(--brand-yellow);
          text-transform: uppercase;
        }

        .match-item span {
          font-weight: 950;
          color: white;
          opacity: 0.75;
        }

        .match-item strong {
          font-size: clamp(18px, 4vw, 32px);
          line-height: 1;
          font-weight: 950;
          text-align: right;
        }

        @media (max-width: 640px) {
          .games-section {
            // padding: 52px 0 60px;
          }

          .match-item {
            align-items: flex-start;
            flex-direction: column;
            padding: 12px 0;
          }

          .match-item strong {
            text-align: left;
          }
        }
      `}</style>
    </section>
  );
}
